module.exports = __webpack_public_path__ + "img/csm_Geschichte_Einst-und-heute_03_5156e2a87b.0c17b9c0.jpg";